jQuery(document).ready(function(){
  Shopify.money_format = '&pound;';
  $('.mini-cart').append('<div class="mini-cart__full"><ul class="mini-cart__items is-cart__items"></ul></div>')
  $('.mini-cart').append('<footer class="mini-cart__footer is-cart__footer"><div class="mini-cart__total"><span class="mini-cart__total-label">Total</span><span class="mini-cart__total-price" data-money-convertible=""></span></div><form action="/cart" method="POST"><a href="/cart" class="button button--full button--primary">'+'Continue to checkout'+'</a></form></footer>')

  $('.mini-cart__footer').css('display','none');
  //console.log('dom ready append')

});

var __isp_options = {

  isp_add_to_cart_callback: function(data) {
      product_form = $(data).find('.isp_add_to_cart_form');
      var addToCartBtn = $('#form_' + data).find('.isp_add_to_cart_btn');
      // console.log('WITH DATA', addToCartBtn, data);
      var data = $(product_form).serialize();

      isp_add_to_cart(data, addToCartBtn);

  }
}

function isp_add_to_cart(data, addToCartBtn) {
  var data = $(data).find('.isp_grid_product')
  var product_id = $(data).find(".isp_grid_product").attr("product_id");
  // console.log('isp_add_to_cart', event, data, addToCartBtn)
  $.ajax({
    type: 'POST',
    url: '/cart?view=mini-cart-content/add?id=' + product_id,
    async: false,
    cache: false,
    dataType: 'json',
    error: addToCartFail,
    success: function(jqXHR, textStatus, errorThrown) {
      // console.log('success', jqXHR, textStatus, errorThrown, addToCartBtn)
      addToCartSuccess(jqXHR, textStatus, errorThrown, addToCartBtn)
    }
  });

  return false;
}

function addToCartSuccess (jqXHR, textStatus, errorThrown, addToCartBtn){
  $(addToCartBtn).attr('value','ADDED TO BASKET');
  //console.log(addToCartBtn);
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: buildCartTable
  });

}

function addToCartFail(jqXHR, textStatus, errorThrown){
  $('#add-to-cart-msg').hide().addClass('error').html(jqXHR.description).fadeIn();
  //console.log('error adding to the cart')
}

function buildCartTable(data) {
console.log(data);
<!-- return; -->
  $.getJSON('/cart.js').then(function(results) {
    if (results['item_count'] > 0) {
      $('.cart-icon-wrapper__count').text(results['item_count']);

      $('.cart-icon-wrapper--has-items').show();
      $('.cart-icon-wrapper--empty').hide();
      $('.mini-cart__empty').hide();
      $('.mini-cart__footer').show();
      console.log('show footer')
    }
  });

  //console.log('build cart table')

  $.each(data.items.slice(0, 1), function (index,item) {
   //console.log('append item to cart');
   $('.is-cart__items').append('<div class="mini-cart__item"><div class="mini-cart__image-container"><a href="#" class="mini-cart__remove icon-cross-container" data-action="remove-product"><svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg></a><img class="mini-cart__image" src="'+item.image+'"></div><div class="product-meta"><span class="cart-item__brand">'+item.title+'</span><h2 class="product-meta__title">'+'1 X '+'<span class="product-meta__title cart-item__title product-tag">'+item.product_description+'<span class="dot"></span><span class="dot"></span></span></h2><span class="product-meta__price" data-money-convertible="">'+Shopify.formatMoney(item.line_price)+'</span></div></div>');
 });

 if ($('.is-cart__footer').length) {
   //console.log('hide duplicate footer')
   $('.mini-cart__content .mini-cart__footer').addClass('hidden');
 }

  $('.mini-cart__total-price').text('Total: '+Shopify.formatMoney(data.total_price));
  $('.cart-item-count').text('( '+data.item_count+' )')
}
